module.exports = __webpack_public_path__ + "img/zhaoyu.eff712ef.jpeg";